import React from 'react'
import { Link } from 'gatsby'

import Layout from '../../components/layout'
import Image from '../images/ed-bodensiek.jpg'
import SEO from '../../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="Edwin Bodensiek" keywords={[]} />
    <div id="main" role="main">
      {' '}
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 className="page-title">Edwin Bodensiek</h1>
        <div>
          <p>
            <img
              className="alignleft size-full wp-image-357"
              style={{ float: 'left' }}
              title="edwin-bodensiek"
              src={Image}
              alt
              width={200}
              height={245}
            />
            When Edwin “Ed” Bodensiek was named Chief Experience Officer of
            Maryland powerhouse Miles &amp; Stockbridge in 2016, he became the
            first CXO in the <em>Am Law 200</em>. In this role, Ed led the
            charge on delivering a comprehensive, premier client service
            experience for the firm. His key focus has been aligning the voice
            of the client to the firm’s strategy and services, as well as
            enhancing employee experience through culture design.
          </p>
          <p>
            Before developing a CX model for big law, Ed served as head of brand
            and communications for Select Medical (NYSE: SEM). In 2011, while Ed
            was building an in-house comms agency for the national healthcare
            giant, the company’s CEO asked him to design a sweeping change
            management effort around patient and employee experience. That
            became the Select Medical Way, the defining touchstone of how the $5
            billion company continues to do business today – with core values,
            patients and colleagues at its core. It was in this dual role that
            Ed became convinced that CX was the next evolutionary step for a new
            form of branding.
          </p>
          <p>
            At <em>Gómez &amp; Associates</em>, Ed offers design thinking
            workshops and discovery sessions for new strategies to sharpen
            purpose and shape customer interactions so organizations can learn
            how to create raving fans inside and outside. Ed also has expertise
            and consults on product and talent branding strategy.
          </p>
          <p>
            Ed’s background includes communications and marketing leadership
            roles with the U.S. Fulbright Scholar Program, Johns Hopkins
            University, and JA Worldwide. Ed was also a presidential appointee
            with the U.S. Department of the Treasury. He is the founder of
            Cravety, which helps clients create brands people crave – with the
            workplace culture top talent craves. His firm can measure customer
            centricity through a new form of culture analytics. He is a graduate
            of Florida Atlantic University, and holds a certificate in bioethics
            from Georgetown University.
          </p>
          <p>
            Phone: 202.550.6903 | Email:{' '}
            <a href="mailto:Ed@cravety.com">Ed@cravety.com </a>
          </p>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
